<template>
<div id="app-ead">
    <router-view></router-view>
</div>
</template>
<script>

import router from '../../router'
import urlApi from '../../router/urlApiV2'

export default {
    name: 'app-ead',

    components: {
    },
    data () {
        return {
            //
        }
    },
    created() {
        if(this.$route.params.token)
        {
            window.localStorage.setItem('token', atob(this.$route.params.token))

            this.$http.get(urlApi+'/user/dados').then((response) => {
                console.log(response)
                window.localStorage['schema']   = response.body.dados.schema
                window.localStorage['email']    = response.body.dados.email
                window.localStorage['id_role']  = response.body.dados.id_funcao_usuario

                let agrupamento = {
                    agrupamento:  this.$route.params.agrupamento,
                    instrutor:    false
                }

                sessionStorage.setItem('agrupamento', JSON.stringify(agrupamento));
            })
        }
        if(this.$route.params.link)
        {
            try {
                sessionStorage.setItem('link', atob(atob(this.$route.params.link)));
            } catch (error) {
                router.push({ name: 'loginAluno' })
            }
        }else if(!this.$route.params.link && !sessionStorage.getItem('link'))
        {
            router.push({ name: 'loginAluno' })
        }
    }
}
</script>